import { AxiosError } from "axios";

import { apiBackofficeT2b } from "@/lib/axios";

const baseLoginUrl = "/v1/login";

export async function getUserInternalAccessToken() {
  const INTERNAL_USER_EMAIL =
    import.meta.env.VITE_INTERNAL_USER_EMAIL || "tecnologia@talk2buy.com.br";
  const INTERNAL_USER_PASSWORD = import.meta.env.VITE_INTERNAL_USER_PASSWORD || "Talk2buy@2023";

  try {
    const response = await apiBackofficeT2b.post(baseLoginUrl, {
      login: INTERNAL_USER_EMAIL,
      password: INTERNAL_USER_PASSWORD,
    });

    const accessToken = response.data.accessToken;
    return { accessToken };
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Failed to get internal access token");
    }
    throw new Error("Failed to get internal access token");
  }
}
